var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLine2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 22,
    viewBox: "0 0 70 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7766_53932)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.9718 5.70819L55.5024 11.4054H14.4976L9.0387 5.70819H60.9718Z",
    fill: "#C53437"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70 0L64.5411 5.70817H5.45891L0 0H70Z",
    fill: "#E34A4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35 22L13.9202 0H56.0797L35 22Z",
    fill: "#00ACCD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8611 2.07074H34.1706V12.6982H31.8611V2.07074Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.8188 2.07074H38.1284V12.6982H35.8188V2.07074Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7766_53932"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLine2);
export default __webpack_public_path__ + "static/media/line_2.9504e172e2f6ada01c05762f69585513.svg";
export { ForwardRef as ReactComponent };